module.exports = __webpack_public_path__ + "img/decor.fb5c78a7.png";